import { safeLocalStorage } from '@fluidx/utilities';

/**
 * Returns true if local storage says we should have the the fluid debugger enabled
 */
export function isFluidDebuggerEnabled(): boolean {
  return !!(safeLocalStorage()?.FluidDebugger === '1');
}
